// (() => {
//   "use strict";

//   const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
//   const lerp = (a, b, t) => a + (b - a) * t;
//   const padNum = (n, p) => String(n).padStart(p, "0");

//   function revealRows() {
//     document.querySelectorAll("[data-modes] .row").forEach((row) => {
//       const rect = row.getBoundingClientRect();
//       if (rect.top < window.innerHeight * 0.8) row.classList.add("is-visible");
//     });
//   }

//   function initSection(section) {
//     const canvas = section.querySelector(".productCanvas");
//     const sticky = section.querySelector(".movingSticky");
//     if (!canvas || !sticky) return;

//     const ctx = canvas.getContext("2d", { alpha: true });
//     if (!ctx) return;

//     const prefix = section.dataset.prefix || "";
//     const count = parseInt(section.dataset.count || "0", 10);
//     const pad = parseInt(section.dataset.pad || "2", 10);
//     const ext = section.dataset.ext || "png";
//     const sens = parseFloat(section.dataset.sensitivity || "1.4");

//     const ECO_FRAME = parseInt(section.dataset.eco || "0", 10);
//     const BOOST_FRAME = parseInt(section.dataset.boost || String(Math.floor(count / 2)), 10);
//     const FINAL_FRAME = parseInt(section.dataset.final || String(count - 1), 10);

//     if (!prefix || !count || count < 2) return;

//     const frameUrl = (i) => `${prefix}${padNum(i, pad)}.${ext}`;

//     // Preload frames
//     const cache = new Array(count);
//     for (let i = 0; i < count; i++) {
//       const img = new Image();
//       img.decoding = "async";
//       img.src = frameUrl(i);
//       cache[i] = img;
//     }

//     let lastFrame = -1;

//     function draw(idx) {
//       const img = cache[idx];
//       if (!img || !img.complete || !img.naturalWidth) return;

//       // Match canvas to actual image size
//       if (canvas.width !== img.naturalWidth || canvas.height !== img.naturalHeight) {
//         canvas.width = img.naturalWidth;
//         canvas.height = img.naturalHeight;
//       }

//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       ctx.drawImage(img, 0, 0);
//     }

//     cache[0].addEventListener("load", () => draw(0), { once: true });

//     function getProgress() {
//       const r = section.getBoundingClientRect();
//       const vh = window.innerHeight;
//       const total = r.height - vh;
//       const raw = (-r.top) / (total <= 0 ? 1 : total);

//       const stretch = window.matchMedia("(max-width:900px)").matches ? 0.55 : 0.8;
//       return clamp(raw * sens * stretch, 0, 1);
//     }

//     function getCenters() {
//       const ecoSlot = section.querySelector(".row--eco .slot");
//       const boostSlot = section.querySelector(".row--boost .slot");
//       const finalSlot = section.querySelector(".row--final .slot");
//       if (!ecoSlot || !boostSlot || !finalSlot) return null;

//       const eco = ecoSlot.getBoundingClientRect();
//       const boost = boostSlot.getBoundingClientRect();
//       const final = finalSlot.getBoundingClientRect();

//       return {
//         ecoX: eco.left + eco.width / 2,
//         ecoY: eco.top + eco.height / 2,
//         boostX: boost.left + boost.width / 2,
//         boostY: boost.top + boost.height / 2,
//         finalX: final.left + final.width / 2,
//         finalY: final.top + final.height / 2,
//       };
//     }

//     function update() {
      
//       const p = getProgress();
//       const centers = getCenters();
//       if (!centers) return;
      

//       const stickyRect = sticky.getBoundingClientRect();

//       const w = canvas.getBoundingClientRect().width || 1;
//       const h = canvas.getBoundingClientRect().height || 1;

//       // viewport -> sticky local
//       const ecoX = centers.ecoX - stickyRect.left;
//       const ecoY = centers.ecoY - stickyRect.top;
//       const boostX = centers.boostX - stickyRect.left;
//       const boostY = centers.boostY - stickyRect.top;
//       const finalX = centers.finalX - stickyRect.left;
//       const finalY = centers.finalY - stickyRect.top;
//    const isMobile = window.matchMedia("(max-width: 900px)").matches;
//    const ecoOffsetX   = isMobile ? -95 : 200;
//    const boostOffsetX = isMobile ?  -20 : -120;
//    const finalOffsetX = isMobile ? -95 : 200;

//    let x, y, idx;

//    if (p < 0.5) {
//      const t = p / 0.5;

//      x = lerp(ecoX + ecoOffsetX, boostX + boostOffsetX, t);
//      y = lerp(ecoY, boostY, t);

//      idx = Math.round(lerp(ECO_FRAME, BOOST_FRAME, t));
//    } else {
//      const t = (p - 0.5) / 0.5;

//      x = lerp(boostX + boostOffsetX, finalX + finalOffsetX, t);
//      y = lerp(boostY, finalY, t);

//      idx = Math.round(lerp(BOOST_FRAME, FINAL_FRAME, t));
//    }

//    // ✅ MOBILE SAFETY: keep canvas fully inside screen
//    if (isMobile) {
//      const margin = 8; // small padding from edges
//      const stickyW = stickyRect.width;

//      const minX = w / 2 + margin;
//      const maxX = stickyW - w / 2 - margin;

//      x = clamp(x, minX, maxX);
//    }


//       idx = clamp(idx, 0, count - 1);

//       if (idx !== lastFrame) {
//         draw(idx);
//         lastFrame = idx;
//       }

//       // cinematic lift at start
//       const lift = (-180 + 140 * (1 - p)) * (1 - p);

//       canvas.style.transform = `translate3d(${x - w / 2}px, ${y - h / 2 + lift}px, 0)`;
//     }

//     // RAF loop (smooth + stable)
//     let raf = 0;
//     const loop = () => {
//       update();
//       raf = requestAnimationFrame(loop);
//     };
//     loop();

//     // resize safe
//     window.addEventListener(
//       "resize",
//       () => {
//         lastFrame = -1;
//         update();
//       },
//       { passive: true }
//     );
//   }

//   document.addEventListener("DOMContentLoaded", () => {
//     revealRows();
//     window.addEventListener("scroll", revealRows, { passive: true });

//     document.querySelectorAll("[data-modes]").forEach(initSection);
//   });
// })();

// (() => {
//   "use strict";

//   const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
//   const lerp = (a, b, t) => a + (b - a) * t;
//   const padNum = (n, p) => String(n).padStart(p, "0");

//   function revealRows() {
//     document.querySelectorAll("[data-modes] .row").forEach((row) => {
//       const rect = row.getBoundingClientRect();
//       if (rect.top < window.innerHeight * 0.85) {
//         row.classList.add("is-visible");
//       }
//     });
//   }
//   // Spec card animation trigger
//   function initSpecCard() {
//     const card = document.querySelector(".spec-card");
//     if (!card) return;

//     let animated = false;

//     function tryAnimate() {
//       if (animated) return;
//       const rect = card.getBoundingClientRect();
//       if (rect.top < window.innerHeight * 0.85) {
//         animated = true;
//         card.classList.add("is-animated");
//         animateSpecDigits(card);
//       }
//     }

//     window.addEventListener("scroll", tryAnimate, { passive: true });
//     tryAnimate();
//   }

//   // function animateSpecDigits(card) {
//   //   card.querySelectorAll(".spec-card__digits").forEach((container, metricIndex) => {
//   //     const value = container.dataset.value || "";
//   //     container.innerHTML = "";

//   //     [...value].forEach((char) => {
//   //       const wrap = document.createElement("span");
//   //       wrap.className = "sc-digit-wrap";
//   //       const digit = document.createElement("span");
//   //       digit.className = "sc-digit";
//   //       digit.textContent = char;
//   //       wrap.appendChild(digit);
//   //       container.appendChild(wrap);
//   //     });

//   //     const digits = container.querySelectorAll(".sc-digit");
//   //     const baseDelay = metricIndex === 0 ? 500 : 950;

//   //     digits.forEach((digit, i) => {
//   //       setTimeout(() => digit.classList.add("sc-show"), baseDelay + i * 80);
//   //     });

//   //     // animate unit if present
//   //     const unitEl = container.closest(".spec-card__metric-row")?.querySelector(".spec-card__unit");
//   //     if (unitEl) {
//   //       const unitDelay = metricIndex === 0 ? 800 : 1320;
//   //       setTimeout(() => unitEl.classList.add("sc-show"), unitDelay);
//   //     }
//   //   });
//   // }
//   function animateSpecDigits(card) {
//     card.querySelectorAll(".spec-card__metric").forEach((metric, metricIndex) => {
//       const digitsText = metric.dataset.digits || "";
//       const unitText   = metric.dataset.unit   || "";

//       const container = metric.querySelector(".spec-card__digits");
//       const unitEl    = metric.querySelector(".spec-card__unit");

//       if (!container) return;

//       container.innerHTML = "";

//       [...digitsText].forEach((char) => {
//         const wrap = document.createElement("span");
//         wrap.className = "sc-digit-wrap";
//         const digit = document.createElement("span");
//         digit.className = "sc-digit" + (char === "," ? " sc-comma" : "");
//         digit.textContent = char;
//         wrap.appendChild(digit);
//         container.appendChild(wrap);
//       });

//       const digits = container.querySelectorAll(".sc-digit");
//       const baseDelay = 500 + metricIndex * 450;

//       digits.forEach((digit, i) => {
//         setTimeout(() => digit.classList.add("sc-show"), baseDelay + i * 80);
//       });

//       if (unitEl && unitText) {
//         unitEl.textContent = unitText;
//         const unitDelay = baseDelay + (digitsText.length - 1) * 80 + 120;
//         setTimeout(() => unitEl.classList.add("sc-show"), unitDelay);
//       }
//     });
//   }
//     function initSection(section) {
//       const canvas = section.querySelector(".productCanvas");
//       const sticky = section.querySelector(".movingSticky");
//       if (!canvas || !sticky) return;

//       const ctx = canvas.getContext("2d", { alpha: true });
//       if (!ctx) return;

//       const prefix = section.dataset.prefix || "";
//       const count = parseInt(section.dataset.count || "0", 10);
//       const pad = parseInt(section.dataset.pad || "2", 10);
//       const ext = section.dataset.ext || "png";
//       const sens = parseFloat(section.dataset.sensitivity || "1.4");

//       const ECO_FRAME = parseInt(section.dataset.eco || "0", 10);
//       const BOOST_FRAME = parseInt(section.dataset.boost || Math.floor(count / 3), 10);
//       const FINAL_FRAME = parseInt(section.dataset.final || Math.floor(count * 0.66), 10);
//       const EXTRA_FRAME = parseInt(section.dataset.extra || Math.floor(count * 0.8), 10);
//       const EXTRA1_FRAME = parseInt(section.dataset.extra1 || count - 1, 10);

//       if (!prefix || !count || count < 2) return;

//       const frameUrl = (i) => `${prefix}${padNum(i, pad)}.${ext}`;

//       const cache = new Array(count);
//       for (let i = 0; i < count; i++) {
//         const img = new Image();
//         img.decoding = "async";
//         img.src = frameUrl(i);
//         cache[i] = img;
//       }

//       let lastFrame = -1;
//       let smoothX = null;
//       let smoothY = null;

//       function draw(idx) {
//         const img = cache[idx];
//         if (!img || !img.complete || !img.naturalWidth) return;

//         if (canvas.width !== img.naturalWidth || canvas.height !== img.naturalHeight) {
//           canvas.width = img.naturalWidth;
//           canvas.height = img.naturalHeight;
//         }

//         ctx.clearRect(0, 0, canvas.width, canvas.height);
//         ctx.drawImage(img, 0, 0);
//       }

//       cache[0].addEventListener("load", () => draw(0), { once: true });

//       function getProgress() {
//         const r = section.getBoundingClientRect();
//         const vh = window.innerHeight;
//         const total = r.height - vh;
//         const raw = (-r.top) / (total <= 0 ? 1 : total);

//         const isMobile = window.matchMedia("(max-width: 900px)").matches;
//         const stretch = isMobile ? 0.75 : 0.95;

//         return clamp(raw * sens * stretch, 0, 1);
//       }

//       function getRects() {
//         const rows = ["eco", "boost", "final", "extra", "extra-1"].map((name) => ({
//           slot: section.querySelector(`.row--${name} .slot`)
//         }));

//         if (rows.some((r) => !r.slot)) return null;
//         return rows.map((r) => r.slot.getBoundingClientRect());
//       }

//       function getSceneTravel(rowCenters, viewportCenter) {
//         if (rowCenters.length < 2) return 0;

//         if (viewportCenter <= rowCenters[0]) return 0;
//         if (viewportCenter >= rowCenters[rowCenters.length - 1]) return rowCenters.length - 1;

//         for (let i = 0; i < rowCenters.length - 1; i++) {
//           const a = rowCenters[i];
//           const b = rowCenters[i + 1];

//           if (viewportCenter >= a && viewportCenter <= b) {
//             const t = clamp((viewportCenter - a) / (b - a || 1), 0, 1);
//             return i + t;
//           }

//           if (viewportCenter <= a && viewportCenter >= b) {
//             const t = clamp((a - viewportCenter) / (a - b || 1), 0, 1);
//             return i + t;
//           }
//         }

//         return 0;
//       }

//       function update() {
//         const rects = getRects();
//         if (!rects) return;

//         const p = getProgress();

//         const stickyRect = sticky.getBoundingClientRect();
//         const canvasRect = canvas.getBoundingClientRect();
//         const w = canvasRect.width || 1;
//         const h = canvasRect.height || 1;

//         const isMobile = window.matchMedia("(max-width: 900px)").matches;
//         const SMOOTH = isMobile ? 0.12 : 0.11;
//         const stickyW = stickyRect.width || window.innerWidth;

//         const center = (r) => ({
//           x: r.left + r.width / 2 - stickyRect.left,
//           y: r.top + r.height / 2 - stickyRect.top
//         });

//         const eco = center(rects[0]);
//         const boost = center(rects[1]);
//         const final = center(rects[2]);
//         const extra = center(rects[3]);
//         const extra1 = center(rects[4]);

//         let ecoX, boostX, finalX, extraX, extra1X;

//         if (isMobile) {
//           ecoX = eco.x + stickyW * 0.03;
//           boostX = boost.x - stickyW * 0.04;
//           finalX = final.x + stickyW * 0.03;
//           extraX = extra.x - stickyW * 0.03;
//           extra1X = extra1.x - stickyW * 0.02;
//         } else {
//           ecoX = eco.x - stickyW * 0.08;
//           boostX = boost.x + stickyW * 0.02;
//           finalX = final.x - stickyW * 0.02;
//           extraX = extra.x + stickyW * 0.12;
//           extra1X = extra1.x - stickyW * 0.02;
//         }

//         const points = [
//           { x: ecoX, y: eco.y, frame: ECO_FRAME },
//           { x: boostX, y: boost.y, frame: BOOST_FRAME },
//           { x: finalX, y: final.y, frame: FINAL_FRAME },
//           { x: extraX, y: extra.y, frame: EXTRA_FRAME },
//           { x: extra1X, y: extra1.y, frame: EXTRA1_FRAME }
//         ];

//         const viewportCenter = window.innerHeight / 2;
//         const rowCenters = rects.map((r) => r.top + r.height / 2);
//         const travel = getSceneTravel(rowCenters, viewportCenter);

//         const baseIndex = clamp(Math.floor(travel), 0, points.length - 2);
//         const t = clamp(travel - baseIndex, 0, 1);

//         const from = points[baseIndex];
//         const to = points[baseIndex + 1];

//         const yLag = isMobile ? 1 : 0.9;

//         const targetX = lerp(from.x, to.x, t);
//         const targetY = from.y + (to.y - from.y) * t * yLag;
//         let idx = Math.round(lerp(from.frame, to.frame, t));

//         idx = clamp(idx, 0, count - 1);

//         if (idx !== lastFrame) {
//           draw(idx);
//           lastFrame = idx;
//         }

//         if (smoothX === null || smoothY === null) {
//           smoothX = targetX;
//           smoothY = targetY;
//         } else {
//           smoothX += (targetX - smoothX) * SMOOTH;
//           smoothY += (targetY - smoothY) * SMOOTH;
//         }

//         // const liftBase = isMobile ? -40 : -120;
//         // const liftRange = isMobile ? 50 : 100;
//         // const lift = (liftBase + liftRange * (1 - p)) * (1 - p);
//         const liftBase = isMobile ? -20 : -60;
//   const liftRange = isMobile ? 30 : 60;
//   const lift = (liftBase + liftRange * (1 - p)) * (1 - p);

//         // canvas.style.transform = `translate3d(${smoothX - w / 2}px, ${smoothY - h / 2 + lift}px, 0)`;

//         // Scene 4 (extra) zoom — keeps same pace, just scales up
//   const scene4Start = 2.5;
//   const scene4End   = 3.5;
//   const scene5Start = 3.5;
//   const scene5End   = 4.5;
//   const zoom4Amount = 1.5;
//   const zoom5Amount = 0.9;

//   let sceneScale = 1;

//   if (travel >= scene4Start && travel <= scene4End) {
//     const zoomT = clamp((travel - scene4Start) / (scene4End - scene4Start), 0, 1);
//     const bell  = Math.sin(zoomT * Math.PI);
//     sceneScale  = 1 + (zoom4Amount - 1) * bell;
//   } else if (travel >= scene5Start) {
//     const zoomT = clamp((travel - scene5Start) / (scene5End - scene5Start), 0, 1);
//     sceneScale  = 1 + (zoom5Amount - 1) * zoomT;
//   }

//   canvas.style.transform = `translate3d(${smoothX - w / 2}px, ${smoothY - h / 2 + lift}px, 0) scale(${sceneScale})`;
//       }

//       const loop = () => {
//         update();
//         requestAnimationFrame(loop);
//       };

//       loop();

//       window.addEventListener(
//         "resize",
//         () => {
//           lastFrame = -1;
//           smoothX = null;
//           smoothY = null;
//           update();
//         },
//         { passive: true }
//       );
//     }

//     document.addEventListener("DOMContentLoaded", () => {
//       revealRows();
//       initSpecCard();
//       window.addEventListener("scroll", revealRows, { passive: true });
//       document.querySelectorAll("[data-modes]").forEach(initSection);
//     });
// })();


(() => {
  "use strict";

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
  const lerp = (a, b, t) => a + (b - a) * t;
  const padNum = (n, p) => String(n).padStart(p, "0");

  function revealRows() {
    document.querySelectorAll("[data-modes] .row").forEach((row) => {
      const rect = row.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) {
        row.classList.add("is-visible");
      }
    });
  }
// Spec card animation trigger
function initSpecCard() {
  const card = document.querySelector(".spec-card");
  if (!card) return;

  let animated = false;

  function tryAnimate() {
    if (animated) return;
    const rect = card.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.85) {
      animated = true;
      card.classList.add("is-animated");
      animateSpecDigits(card);
    }
  }

  window.addEventListener("scroll", tryAnimate, { passive: true });
  tryAnimate();
}

// function animateSpecDigits(card) {
//   card.querySelectorAll(".spec-card__digits").forEach((container, metricIndex) => {
//     const value = container.dataset.value || "";
//     container.innerHTML = "";

//     [...value].forEach((char) => {
//       const wrap = document.createElement("span");
//       wrap.className = "sc-digit-wrap";
//       const digit = document.createElement("span");
//       digit.className = "sc-digit";
//       digit.textContent = char;
//       wrap.appendChild(digit);
//       container.appendChild(wrap);
//     });

//     const digits = container.querySelectorAll(".sc-digit");
//     const baseDelay = metricIndex === 0 ? 500 : 950;

//     digits.forEach((digit, i) => {
//       setTimeout(() => digit.classList.add("sc-show"), baseDelay + i * 80);
//     });

//     // animate unit if present
//     const unitEl = container.closest(".spec-card__metric-row")?.querySelector(".spec-card__unit");
//     if (unitEl) {
//       const unitDelay = metricIndex === 0 ? 800 : 1320;
//       setTimeout(() => unitEl.classList.add("sc-show"), unitDelay);
//     }
//   });
// }
function animateSpecDigits(card) {
  card.querySelectorAll(".spec-card__metric").forEach((metric, metricIndex) => {
    const digitsText = metric.dataset.digits || "";
    const unitText   = metric.dataset.unit   || "";

    const container = metric.querySelector(".spec-card__digits");
    const unitEl    = metric.querySelector(".spec-card__unit");

    if (!container) return;

    container.innerHTML = "";

    [...digitsText].forEach((char) => {
      const wrap = document.createElement("span");
      wrap.className = "sc-digit-wrap";
      const digit = document.createElement("span");
      digit.className = "sc-digit" + (char === "," ? " sc-comma" : "");
      digit.textContent = char;
      wrap.appendChild(digit);
      container.appendChild(wrap);
    });

    const digits = container.querySelectorAll(".sc-digit");
    const baseDelay = 500 + metricIndex * 450;

    digits.forEach((digit, i) => {
      setTimeout(() => digit.classList.add("sc-show"), baseDelay + i * 80);
    });

    if (unitEl && unitText) {
      unitEl.textContent = unitText;
      const unitDelay = baseDelay + (digitsText.length - 1) * 80 + 120;
      setTimeout(() => unitEl.classList.add("sc-show"), unitDelay);
    }
  });
}
  function initSection(section) {
    const canvas = section.querySelector(".productCanvas");
    const sticky = section.querySelector(".movingSticky");
    if (!canvas || !sticky) return;

    const ctx = canvas.getContext("2d", { alpha: true });
    if (!ctx) return;

    const prefix = section.dataset.prefix || "";
    const count = parseInt(section.dataset.count || "0", 10);
    const pad = parseInt(section.dataset.pad || "2", 10);
    const ext = section.dataset.ext || "png";
    const sens = parseFloat(section.dataset.sensitivity || "1.4");

    const ECO_FRAME = parseInt(section.dataset.eco || "0", 10);
    const BOOST_FRAME = parseInt(section.dataset.boost || Math.floor(count / 3), 10);
    const FINAL_FRAME = parseInt(section.dataset.final || Math.floor(count * 0.66), 10);
    const EXTRA_FRAME = parseInt(section.dataset.extra || Math.floor(count * 0.8), 10);
    const EXTRA1_FRAME = parseInt(section.dataset.extra1 || count - 1, 10);

    if (!prefix || !count || count < 2) return;

    const frameUrl = (i) => `${prefix}${padNum(i, pad)}.${ext}`;

    const cache = new Array(count);
    for (let i = 0; i < count; i++) {
      const img = new Image();
      img.decoding = "async";
      img.src = frameUrl(i);
      cache[i] = img;
    }

    let lastFrame = -1;
    let smoothX = null;
    let smoothY = null;

    function draw(idx, imageScale = 1) {
  const img = cache[idx];
  if (!img || !img.complete || !img.naturalWidth) return;

  if (canvas.width !== img.naturalWidth || canvas.height !== img.naturalHeight) {
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
  }

  const cw = canvas.width;
  const ch = canvas.height;

  const drawW = cw * imageScale;
  const drawH = ch * imageScale;

  const dx = (cw - drawW) / 2;
  const dy = (ch - drawH) / 2;

  ctx.clearRect(0, 0, cw, ch);
  ctx.drawImage(img, dx, dy, drawW, drawH);
}

    cache[0].addEventListener("load", () => draw(0), { once: true });

    function getProgress() {
      const r = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const total = r.height - vh;
      const raw = (-r.top) / (total <= 0 ? 1 : total);

      const isMobile = window.matchMedia("(max-width: 900px)").matches;
      const stretch = isMobile ? 0.75 : 0.95;

      return clamp(raw * sens * stretch, 0, 1);
    }

    function getRects() {
      const rows = ["eco", "boost", "final", "extra"].map((name) => ({
        slot: section.querySelector(`.row--${name} .slot`)
      }));

      if (rows.some((r) => !r.slot)) return null;
      return rows.map((r) => r.slot.getBoundingClientRect());
    }

    function getSceneTravel(rowCenters, viewportCenter) {
      if (rowCenters.length < 2) return 0;

      if (viewportCenter <= rowCenters[0]) return 0;
      if (viewportCenter >= rowCenters[rowCenters.length - 1]) return rowCenters.length - 1;

      for (let i = 0; i < rowCenters.length - 1; i++) {
        const a = rowCenters[i];
        const b = rowCenters[i + 1];

        if (viewportCenter >= a && viewportCenter <= b) {
          const t = clamp((viewportCenter - a) / (b - a || 1), 0, 1);
          return i + t;
        }

        if (viewportCenter <= a && viewportCenter >= b) {
          const t = clamp((a - viewportCenter) / (a - b || 1), 0, 1);
          return i + t;
        }
      }

      return 0;
    }

    function update() {
      const rects = getRects();
      if (!rects) return;

      const p = getProgress();

      const stickyRect = sticky.getBoundingClientRect();
      const canvasRect = canvas.getBoundingClientRect();
      const w = canvasRect.width || 1;
      const h = canvasRect.height || 1;

      const isMobile = window.matchMedia("(max-width: 900px)").matches;
      const SMOOTH = isMobile ? 0.12 : 0.11;
      const stickyW = stickyRect.width || window.innerWidth;

      const center = (r) => ({
        x: r.left + r.width / 2 - stickyRect.left,
        y: r.top + r.height / 2 - stickyRect.top
      });

      const eco = center(rects[0]);
      const boost = center(rects[1]);
      const final = center(rects[2]);
      const extra = center(rects[3]);

      let ecoX, boostX, finalX, extraX;

      if (isMobile) {
        ecoX = eco.x + stickyW * 0.03;
        boostX = boost.x - stickyW * 0.04;
        finalX = final.x + stickyW * 0.03;
        extraX = extra.x - stickyW * 0.03;
      } else {
        ecoX = eco.x - stickyW * 0.08;
        boostX = boost.x + stickyW * 0.02;
        finalX = final.x - stickyW * 0.02;
        extraX = extra.x + stickyW * 0.05;
      }

      const points = [
        { x: ecoX, y: eco.y, frame: ECO_FRAME },
        { x: boostX, y: boost.y, frame: BOOST_FRAME },
        { x: finalX, y: final.y, frame: FINAL_FRAME },
        { x: extraX, y: extra.y, frame: EXTRA_FRAME }
      ];

      const viewportCenter = window.innerHeight / 2;
      const rowCenters = rects.map((r) => r.top + r.height / 2);
      const travel = getSceneTravel(rowCenters, viewportCenter);

      const baseIndex = clamp(Math.floor(travel), 0, points.length - 2);
      const t = clamp(travel - baseIndex, 0, 1);

      const from = points[baseIndex];
      const to = points[baseIndex + 1];

      const yLag = isMobile ? 1 : 0.9;

      const targetX = lerp(from.x, to.x, t);
      const targetY = from.y + (to.y - from.y) * t * yLag;
      let idx = Math.round(lerp(from.frame, to.frame, t));
      idx = clamp(idx, 0, count - 1);

      let imageScale = 1;

      // final -> extra = scene-3 -> scene-4
      if (baseIndex === 2) {
        imageScale = lerp(isMobile ? 1.0 : 1.0, isMobile ? 1.45 : 1.6, t);
      } else if (travel >= 3) {
        imageScale = isMobile ? 1.45 : 1.6;
      }

draw(idx, imageScale);
lastFrame = idx;

      if (smoothX === null || smoothY === null) {
        smoothX = targetX;
        smoothY = targetY;
      } else {
        smoothX += (targetX - smoothX) * SMOOTH;
        smoothY += (targetY - smoothY) * SMOOTH;
      }

      // const liftBase = isMobile ? -40 : -120;
      // const liftRange = isMobile ? 50 : 100;
      // const lift = (liftBase + liftRange * (1 - p)) * (1 - p);
      const liftBase = isMobile ? -20 : -60;
      const liftRange = isMobile ? 30 : 60;
      const lift = (liftBase + liftRange * (1 - p)) * (1 - p);
      /* zoom only from scene-3 to scene-4 */
      let scale = 1;

      if (baseIndex === 2) {
        scale = lerp(isMobile ? 0.58 : 0.55, 1, t);
      } else if (travel >= 3) {
        scale = 1;
      }

      // canvas.style.transform = `translate3d(${smoothX - w / 2}px, ${smoothY - h / 2 + lift}px, 0)`;
      canvas.style.transform = `translate3d(${smoothX - w / 2}px, ${smoothY - h / 2 + lift}px, 0)`;
      canvas.style.transformOrigin = "center center";
    }

    const loop = () => {
      update();
      requestAnimationFrame(loop);
    };

    loop();

    window.addEventListener(
      "resize",
      () => {
        lastFrame = -1;
        smoothX = null;
        smoothY = null;
        update();
      },
      { passive: true }
    );
  }

  document.addEventListener("DOMContentLoaded", () => {
    revealRows();
    initSpecCard();
    window.addEventListener("scroll", revealRows, { passive: true });
    document.querySelectorAll("[data-modes]").forEach(initSection);
  });
})();